export default __webpack_public_path__ + "static/media/edit.56d569b5.svg";